import { PaletteColorOptions } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';


// https://colorkit.co/palette/164273-3F9CD5-B3D7EF-D9EBF7-75D2B7-F48E4A-FFDD4A/ 
declare module '@mui/material/styles' {
    interface Palette {
      custom: {
        b1: string;
        b2: string;
        b3: string;
        b4: string;
        lg: string;
        or: string;
        ye: string;
      };
    }
  
    interface PaletteOptions {
      custom?: {
        b1: string;
        b2: string;
        b3: string;
        b4: string;
        lg: string;
        or: string;
        ye: string;
      };
    }
  }



const theme = createTheme({
  palette: {
    custom: {
        //contrast ratios. "For the highest level of usability WCAG recommends a 7:1 contrast ratio for text that is designed for users with 20/80 vision"
        b1: '#164273', //2.06:1 with black, 10.18:1 with white -> WHITE
        b2: '#3F9CD5', //6.92:1 with black, 3.03:1 with white -> BLACK
        b3: '#B3D7EF', //13.88:1 with black, 1.51:1 with white -> BLACK
        b4: '#D9EBF7', //17.17:1 with black, 1.22:1 with white -> BLACK
        lg: '#75D2B7', //11.65:1 with black, 1.8:1 with white -> BLACK
        or: '#F48E4A', //8.81:1 with black, 2.38:1 with white -> BLACK
        ye: '#FFDD4A'  //15.69:1 with black,  1.33:1 with white -> BLACK
    },
  },
});

export default theme